import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class PreciosService extends BaseService<any>{

  private static PRECIO_RESOURCE: string = "/precios";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public savePrecio(precio: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (precio.id == null) {
      this.post(BaseService.URL_BASE + PreciosService.PRECIO_RESOURCE, precio, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + PreciosService.PRECIO_RESOURCE, precio, options, onSuccess);
    }
  }

  public deletePrecio(precio: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + PreciosService.PRECIO_RESOURCE + "/" + precio.id, options, onSuccess);
  }

  public getPrecio(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + PreciosService.PRECIO_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getPrecios(precioFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + PreciosService.PRECIO_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/precios.service.ts